<ng-container *ngIf="items$ | async"></ng-container>
<ng-container *ngrxLet="packingListResource$ as packingListResource">
  <div id="ch-ggs-web-suite-packing-details" class="tree-view">
    <lib-easydgd-over-packaging-item
      [item]="item"
      [isLast]="
        last &&
        !(compositePackagingItems | filterOverpack).length &&
        !(singlePackagingItems | filterOverpack).length
      "
      [compositePackagingItems]="
        compositePackagingItems | filterOverpack: item.Id
      "
      [singlePackagingItems]="singlePackagingItems | filterOverpack: item.Id"
      *ngFor="let item of overPackagingItems; let last = last"
      (editPackage)="editOverpack($event)"
      (remove)="removeOverpack($event)"
      (duplicateCompositePackage)="copyCompositePackage($event)"
      (duplicateSinglePackage)="copySinglePackage($event)"
      (editCompositePackage)="
        editPackage($event, packingListResource['AddCombinationPackaging'])
      "
      (editSinglePackage)="
        editPackage($event, packingListResource['AddSinglePackaging'])
      "
      (removeCompositePackage)="removeCompositePackage($event)"
      (removeSinglePackage)="removeSinglePackage($event)"
    >
    </lib-easydgd-over-packaging-item>
    <lib-easydgd-composite-packaging-item
      *ngFor="
        let item of compositePackagingItems | filterOverpack;
        let last = last
      "
      [item]="item"
      [isLast]="last && !(singlePackagingItems | filterOverpack).length"
      [showPrintLabel]="true"
      [overpackItems]="overPackagingItems"
      (editPackage)="
        this.editPackage(item, packingListResource['AddCombinationPackaging'])
      "
      (assignOverpack)="assignOverpack($event)"
      (editOverpackItem)="editOverpackItem($event)"
      (duplicateCompositePackage)="copyCompositePackage($event)"
      (removeCompositePackage)="removeCompositePackage($event)"
    ></lib-easydgd-composite-packaging-item>
    <lib-easydgd-single-packaging-item
      *ngFor="
        let item of singlePackagingItems | filterOverpack;
        let last = last
      "
      [item]="item"
      [isLast]="last"
      [overpackItems]="overPackagingItems"
      (editPackage)="
        editPackage(item, packingListResource['AddSinglePackaging'])
      "
      (removePackage)="removeSinglePackage(item)"
      (copyPackage)="copySinglePackage($event)"
      (assignOverpack)="assignOverpack($event)"
      (editOverpackItem)="editOverpackItem($event)"
    ></lib-easydgd-single-packaging-item>
    <span *ngIf="!packageCount">
      <ng-container *ngIf="validationResource$ | async as validationResource">
        {{ validationResource['NoItemsInList'] }}
      </ng-container>
    </span>
  </div>
</ng-container>
